import { CalendarDays, ChevronLeft } from "lucide-react";
import type { CalendarDate } from "@hitl/rotations-domain";
import { formatDay } from "../scan/copy";

/** Today has no route placed on it: say so plainly and point at the planner. */
export function NoRouteToday(props: { today: CalendarDate; onOpenPlan: () => void; onHome?: () => void }) {
  return (
    <main className="empty-today">
      {props.onHome && (
        <button className="plan__back empty-today__home" onClick={props.onHome}>
          <ChevronLeft aria-hidden size={22} />
          Home
        </button>
      )}
      <CalendarDays aria-hidden size={32} strokeWidth={2} />
      <h1>No route today</h1>
      <p>Nothing is planned for {formatDay(props.today)}. Place a route on today in the planner to start scanning.</p>
      <button className="btn btn--light" onClick={props.onOpenPlan}>
        Open the planner
      </button>
    </main>
  );
}
